import { defineComponent, cloneVNode } from "vue";
import { usePageContext } from "../hooks/usePageContext.js";
import { useHydrated } from "../hooks/useHydrated.js";
import { b as assert } from "../assert-CI16lhfz.js";
const ClientOnly = defineComponent({
  name: "ClientOnly",
  inheritAttrs: false,
  slots: {},
  setup(_, { slots, attrs }) {
    const hydrated = useHydrated();
    return () => {
      const pageContext = usePageContext();
      if (!pageContext.isClientSide) assert(slots.default === void 0);
      if (hydrated.value) {
        const vnodes = slots.default?.();
        if (vnodes && vnodes.length === 1) {
          return [cloneVNode(vnodes[0], attrs)];
        }
        return vnodes;
      }
      if (slots["fallback"]) {
        return slots["fallback"]({ attrs });
      }
    };
  }
});
export {
  ClientOnly
};
//# sourceMappingURL=ClientOnly.js.map
